import Paper from '@mui/material/Paper';
import React, { Component } from "react";

export default class EmptyState extends Component {
	render() {
		return (
			<Paper style={{padding: this.props.padding || 20, minHeight: this.props.minHeight || 250, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
              {this.props.children || <h2 style={{width: '100%', color: '#999', fontWeight: 'normal'}}>{this.props.text}</h2>}
			</Paper>
		)
	}
}